export default class Trail {
  constructor(API) {
    this.api = API;
  }
  /*
  {
    'userID': 'string',
    'transactionDate': 'number',
    'eventLevel': 'any',
    'eventType': 'any',
    'userID': 'string',
    //Optionals
    'description': 'any?',
    'eventData': 'any?',
    //Externals -- optional
    'auditKey': 'any',
    'auditSubKey': 'any?',
    //Identifiers
    'requesterID': 'string'
  }
  */
  async createTrail(trailObj) {
    const req = await this.api.newBaseRequest('POST');
    req.path = '/trail/new';
    req.body = trailObj;
    return await req.exec();
  }
  async listTrailByID(trailID, dateFrom, dateTo) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/trail/' + trailID + (dateFrom && dateTo ? `?dateFrom=${dateFrom}&dateTo=${dateTo}` : '');
    return await req.exec();
  }
  async listTrailByIDs(trailID, trailSubID, dateFrom, dateTo) {
    const req = await this.api.newBaseRequest('GET');
    req.path = '/trail/' + trailID + '/' + trailSubID + (dateFrom && dateTo ? `?dateFrom=${dateFrom}&dateTo=${dateTo}` : '');
    return await req.exec();
  }
}
